var ApiLoginWarning = /*#__PURE__*/function (ApiLoginWarning) {
  ApiLoginWarning["PHONE_VERIFICATION"] = "Phone";
  ApiLoginWarning["REGISTER_ACTION"] = "register-patient";
  return ApiLoginWarning;
}(ApiLoginWarning || {});
export default ApiLoginWarning;